import { sanitizeCubeTest } from '.'
import { CreateReceiptInput, Receipt } from '../types'

export default function (receipt: Receipt) {
  const { id, plant, cubeTest, revision, ...data } = receipt
  cubeTest && ((data as CreateReceiptInput).cubeTest = sanitizeCubeTest(cubeTest))
  return data
}
